
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galerie/[slug]",
      function () {
        return require("private-next-pages/galerie/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galerie/[slug]"])
      });
    }
  